import React, { 
    useState, 
    useEffect  
  } from 'react'
  
  import Navbar from '../../Components/Navbar/Navbar'
  import toast from 'react-hot-toast';
  import { 
      Layout,
      Col, 
      Row,
      Button,
      Space,
      Modal,
      Form,
      Input,
      Table,
      Select,
  } from 'antd';
  import { 
    ProductOutlined 
  } from '@ant-design/icons';
  import { UseGetRequest } from '../../Utils/api/ApiRequests'
  import { usePostRequest } from '../../hooks/usePostRequest'
  
  const { Item } = Form;
  const { Option } = Select;
  const { Search } = Input;
  
  const ChangeStatus = () => {
    const [statusForm] = Form.useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [statusModal, setStatusModal] = useState(false);
    const [oldStatus, setOldStatus] = useState(false);
    const [stausData, setStatusData] = useState([]);
    const [memberData, setMembersData] = useState([]);
    const [filterConfig, setFilterConfig] = useState({
      member_id: '',
      term: '',
    })
    const { callPost, loading } = usePostRequest(()=>{
        statusForm.resetFields();
        setStatusModal(false)
        fetchStatusData()
        fetchMembersData()
    });
  
    const customSpinner = <ProductOutlined style={{ fontSize: 24, color: "#005E30"  }} spin />;
  
    const columns = [
      {
          title: 'Member',
          dataIndex: 'member_name',
          key: 'member_name',
          sorter: (a, b) => a.member_name?.localeCompare(b.member_name),
      },
      {
        title: 'Old Status',
        dataIndex: 'old_status',
        key: 'old_status',
        sorter: (a, b) => a.old_status?.localeCompare(b.old_status),
      
      },
      {
        title: 'New Status',
        dataIndex: 'new_status',
        key: 'new_status',
        sorter: (a, b) => a.new_status?.localeCompare(b.new_status),
      },
    ];
  
    async function fetchStatusData() {
      setIsLoading(true)
      const response = await UseGetRequest("members/get_member_status", filterConfig);
      if (response?.data) {
        setStatusData(response?.data?.member_statuses);
      } else {
        setStatusData([])
      }
      setIsLoading(false);
    }

    async function fetchMembersData() {
      setIsLoading(true)
      const response = await UseGetRequest("members/get_all", filterConfig);
      if (response?.data) {
        setMembersData(response?.data?.members);
      } else {
        setMembersData([])
      }
      setIsLoading(false);
    }

    const handleMemberStatus = (e) => {
        const member_data = memberData.filter(item => item.id === e)
        statusForm.setFieldsValue({
            old_status: member_data[0]?.latest_status,
        });
        setOldStatus(member_data[0]?.latest_status)
    }
    
    const handleEditStatus = () => {
        statusForm.validateFields().then(values => {
            const newValues = {
                member_id: values.member_id || '',
                old_status: values.old_status || '',
                new_status: values.new_status || '',
            }

            callPost(
                "members/update_status", 
                newValues,
                false,
            );
        }).catch(errorInfo => { 
          toast.error('Validation Failed ', errorInfo);
        });
    };
  
    const handleTableChange = (pagination) => {
      setFilterConfig((prev) => ({
        ...prev,
        page: parseInt(pagination.current),
        page_size: pagination.pageSize
      }));
    };

    const handleChange = (e) => {
        setFilterConfig((prev) => (
          {
            ...prev,
            term: e || '',
            page: 1,
          }
        ));
    };
      
    const handleEmpty = (e) => {
        if(e.target.value === ''){
          setFilterConfig((prev) => (
            {
              ...prev,
              term: e.target.value || '',
              page: 1,
            }
          ));
        }
    };
  
    useEffect(() => {
        fetchStatusData();
        fetchMembersData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterConfig]);
    
    return (
        <Layout className='page'>
            <Navbar navKey={'status'}/>
            <Layout className='content-container overflow-y'>
                <Row className='custom-padding responsive-tab-inline'>
                    <Col span={15} className='header-container'>
                        CHANGE STATUS
                    </Col>
                    <Col span={9} className='mt-2 responsive-tab-width' align='end'>
                        <Space className='responsive-inline'> 
                            <Search
                                placeholder="Search Member"
                                size='medium'
                                onSearch={(e)=>handleChange(e)}
                                onChange={(e)=>handleEmpty(e)}
                                className='responsive-header-input'
                            />           
                            <Button 
                                className='button-color responsive-header-btn' 
                                onClick={() => setStatusModal(true)} 
                                type="primary"
                            >
                                + Action
                            </Button>         
                        </Space>
                    </Col>
                </Row>
                <Row className='page-content'>
                    <Col span={24} className='responsive-overflow-auto'>
                        <Table 
                            columns={columns} 
                            dataSource={stausData} 
                            loading={{
                            indicator: customSpinner,
                            spinning: isLoading,
                            }}
                            pagination={{
                            defaultPageSize: 10,
                            //   total: pageSize,
                            current: filterConfig?.page,
                            pageSize: filterConfig?.total_records_per_page,
                            }}
                            onChange={handleTableChange}
                        />
                    </Col>
                </Row>
                <Modal
                    title="Change Status"
                    open={statusModal}
                    onOk={handleEditStatus}
                    onCancel={() => setStatusModal(false)}
                    okText="Save"
                    loading={loading}
                    maskClosable={false}
                >
                    <Form 
                        form={statusForm} 
                        layout="vertical"
                    >
                        <Row>
                            <Col span={24}>
                                <Item
                                    label="Member"
                                    name="member_id"
                                >
                                    <Select 
                                        placeholder="Select a property"
                                        onChange={(e) => handleMemberStatus(e)}
                                    >
                                        {
                                            memberData?.map((data) => (
                                                <Option key={data.id} value={data.id}>{data.last_name + " " + data.first_name + " " + data.middle_name}</Option>
                                            ))
                                        }
                                    </Select>
                                </Item>
                            </Col>
                        </Row>
                        <Row>
                            <Space>
                                <Item
                                    label="Old Status"
                                    name="old_status"
                                >
                                    <Input disabled/>
                                </Item>
                           
                                <Item
                                    label="New Status"
                                    name="new_status"
                                    rules={[{ required: true, message: 'Please select your Property' }]} // Adjusted message
                                >
                                    <Select placeholder="Select a Member">
                                        <Option value="Active" disabled={oldStatus === 'Active'}>Active</Option>
                                        <Option value="Inactive" disabled={oldStatus === 'Inactive'}>Inactive</Option>
                                        <Option value="Deferred" disabled={oldStatus === 'Deferred'}>Deferred</Option>
                                        <Option value="Cancelled" disabled={oldStatus === 'Cancelled'}>Cancelled</Option>
                                        <Option value="Delinquent" disabled={oldStatus === 'Delinquent'}>Delinquent</Option>
                                        <Option value="Pending" disabled={oldStatus === 'Pending'}>Pending</Option>
                                        <Option value="Assigned" disabled={oldStatus === 'Assigned'}>Assigned</Option>
                                        <Option value="Transferred" disabled={oldStatus === 'Transferred'}>Transferred</Option>
                                        <Option value="Resigned" disabled={oldStatus === 'Resigned'}>Resigned</Option>
                                        <Option value="Expelled" disabled={oldStatus === 'Expelled'}>Expelled</Option>
                                        <Option value="Suspended" disabled={oldStatus === 'Suspended'}>Suspended</Option>
                                        <Option value="Stop Billing" disabled={oldStatus === 'Stop Billing'}>Stop Billing</Option>
                                        <Option value="Leave Of Absence" disabled={oldStatus === 'Leave Of Absence'}>Leave Of Absence</Option>
                                        <Option value="For Legal" disabled={oldStatus === 'For Legal'}>For Legal</Option>
                                    </Select>
                                </Item>
                            </Space>
                        </Row>
                    </Form>
                </Modal>
            </Layout>
        </Layout>
    )
  }
  
  export default ChangeStatus
  